/**
 *
 * 记录浏览器keys 防止命名冲突
 */
// cookies keys

// sessionStorage keys

export const EXPRESS_INFO = "EXPRESS_INFO"; // expressToken和expressId
// localStorage keys
